import { render, staticRenderFns } from "./ModalBan.vue?vue&type=template&id=15d6e9ca&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"
import style0 from "./ModalBan.vue?vue&type=style&index=0&id=15d6e9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6e9ca",
  null
  
)

export default component.exports